const getFormData = (form: HTMLFormElement) => {
	const formDataObj: { [key: string | symbol | number]: any } = {};
	const formData = new FormData(form);

	formData.forEach((value, key) => {
		formDataObj[key] = value;
	});

	// Compatibility for Gravity Flow User Input step's Non Editable Fields.
	const valueElements = form.querySelectorAll('.gravityflow-field-value');
	valueElements.forEach((valueElement) => {
		// Get value from 'gravityflow-field-value'
		// Get key from the previous label element. (input_x_1, should be saved as input_1)
		const labelElement =
			valueElement.previousElementSibling as HTMLLabelElement;
		if (labelElement && labelElement.classList.contains('gfield_label')) {
			const key = labelElement.getAttribute('for');
			if (key) {
				const modifiedKey = key.replace(/_\d+_/, '_');
				formDataObj[modifiedKey] = valueElement.textContent;
			}
		}
	});

	return formDataObj;
};

export default getFormData;
